// extracted by mini-css-extract-plugin
module.exports = {"overlay":"WGxY0","wrapper":"_2ippY","img-wrapper":"dIz8y","text-wrapper":"_23RN1"};